const topics = [
  { tag: '暑期档', heat: '9.8万讨论', desc: '2026暑期档票房大盘点，国产科幻领跑', color: 'accent' },
  { tag: '悬疑烧脑', heat: '7.2万讨论', desc: '年度悬疑神作预定，反转多达五次', color: 'primary' },
  { tag: '国漫崛起', heat: '6.5万讨论', desc: '国产动画电影再创口碑新高，画风惊艳', color: 'secondary' },
  { tag: '经典重映', heat: '5.8万讨论', desc: '4K修复版经典影片集中回归大银幕', color: 'primary' },
  { tag: '纪录片热', heat: '5.1万讨论', desc: '自然与人文纪录片引发观影新潮流', color: 'accent' },
  { tag: '导演特辑', heat: '4.6万讨论', desc: '新锐导演作品合集，谁是你的年度最佳', color: 'secondary' },
  { tag: '动作大片', heat: '8.3万讨论', desc: '年度动作巨制备受期待，特技场面升级', color: 'primary' },
  { tag: '爱情电影', heat: '4.2万讨论', desc: '治愈系爱情片口碑发酵，温暖整个夏天', color: 'accent' },
  { tag: '科幻宇宙', heat: '6.9万讨论', desc: '国产科幻电影构建全新世界观体系', color: 'secondary' },
  { tag: '恐怖惊悚', heat: '3.7万讨论', desc: '小众恐怖片逆袭，气氛营造堪称教科书', color: 'primary' },
  { tag: '影评精选', heat: '5.4万讨论', desc: '资深影评人年度十佳影片深度解析', color: 'accent' },
];

export default function TopicSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          实时追踪影迷热议焦点，不错过任何一部好片
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((t, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-xs font-bold font-heading ${
                  t.color === 'accent' ? 'bg-accent-500/15 text-accent-400' :
                  t.color === 'secondary' ? 'bg-secondary-500/15 text-secondary-400' :
                  'bg-primary-500/15 text-primary-400'
                }`}>
                  {i + 1}
                </span>
                <span className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors whitespace-nowrap">#{t.tag}</span>
                <span className="text-xs text-foreground-600 ml-auto whitespace-nowrap">{t.heat}</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}